<template>
  <div class="tagview has-background-white-bis fixspace">

    <section class="hero is-medium has-background-white-ter is-bold">
      <div class="hero-body">
        <div class="container has-text-centered">
          <h1 class="title is-3 is-size-3-mobile">
            #{{tag.slug}}
          </h1>
          <h2 class="subtitle py-5 has-text-grey-dark">
            <b>{{ total }}</b> {{ $t('performs.works') }}
          </h2>
        </div>
      </div>
    </section>

    <section class="section">

      <div class="container">
        <hr class="my-6"
            style="border-top:1px solid #000 !important; height:1px !important; width:50px;">
        <p class="is-size-4-desktop is-size-6-mobile has-text-weight-semibold has-text-black mb-5">
          {{ $t('performs.works') }}
        </p>
      </div>

      <div class="container">

        <div class="columns is-multiline" v-if="!isFirstPageFinished">
          <div class="column is-one-third" v-for="i in ske" :key="i">
            <div class="media-content">
              <figure class="image is-16by9 skeleton">
                <div class="skeleton-block"></div>
              </figure>
              <div class="pt-1"><b-skeleton></b-skeleton></div>
              <b-skeleton width="30%"></b-skeleton>
            </div>
          </div>
        </div>

        <div class="columns is-multiline">
          <div class="column is-one-third" v-for="item in list" :key="item.id">
            <router-link :to='"/video/" + item.id' :title="item.title">
              <video-item
                :channel-title="item.channel.title"
                :youtube-id="item.provider_video_id"
                :title="item.title" >
              </video-item>
            </router-link>
          </div>
        </div>

      </div>

      <div class="container has-text-centered" v-if="isEmpty">
        <h2 class="is-size-5-desktop is-size-6-mobile has-text-weight-semibold pb-5">
          Still looking for excellent performance for here
        </h2>
        <button class="button mx-1 px-5 my-5 is-black">
          <span class="has-text-weight-semibold">
            Submit Work
          </span>
        </button>
        <div class="py-6">
          <img src="/assets/empty.png" alt="Placeholder image">
        </div>
      </div>

      <div class="container has-text-centered">
        <infinite-loading
          v-if="isFirstPageFinished"
          spinner="waveDots"
          @infinite="infiniteHandler">
          <div slot="no-more"></div>
          <div slot="no-results"></div>
        </infinite-loading>
      </div>
    </section>
  </div>
</template>

<script>
import { getVideos, getTagBySlug } from '@/api/api';

export default {
  name: 'TagPage',

  metaInfo() {
    return {
      title: `${this.tag.slug} - ${this.$t('title.tags')}`,
      meta: [
        { name: 'description', vmid: 'description', content: this.$t('about.abouthero1') },
        { property: 'og:title', vmid: 'og:title', content: `${this.tag.slug}` },
        { property: 'og:image', vmid: 'og:image', content: 'https://musian.app/assets/open_graph_logo.jpg' },
        { property: 'og:description', vmid: 'og:description', content: this.$t('about.abouthero1') },
      ],
    };
  },

  data() {
    return {
      tag: {
        name: '',
        slug: '',
      },
      currentUrl: '',
      list: [],
      limit: 12,
      page: 1,
      lastPage: 1,
      total: 1,
      isEmpty: false,
      isFirstPageFinished: false,
      ske: 12,
    };
  },
  computed: {
  },

  created() {
    this.currentUrl = window.location.href;
    this.fetchData(this.$route.params.slug, true);
  },

  beforeRouteUpdate(to, from, next) {
    this.page = 1;
    this.isEmpty = false;
    this.isFirstPageFinished = false;
    this.fetchData(to.params.slug);
    next();
  },

  methods: {
    fetchData(slug) {
      getTagBySlug(slug, { headers: { locale: this.$i18n.locale } })
        .then((result) => {
          const infoData = result.data.data;
          this.title = infoData.name;
          this.tag = result.data.data;

          this.$emit('forGtagStatus', `${this.tag.slug} - ${this.$t('title.tags')}`);

          document.title = `${infoData.name} - ${this.$t('title.tags')}`;
        }).catch((err) => {
          console.error(err);

          if (err.request.status === 404) {
            this.$router.push({ name: '404' });
          }
        });

      getVideos({ params: { tags: slug, limit: this.limit, page: this.page } })
        .then((result) => {
          const { data, total, last_page: lastPage } = result.data;
          this.total = total;
          this.lastPage = lastPage;
          this.list = data;

          if (data.length === 0) {
            this.isEmpty = true;
          } else {
            this.page += 1;
          }

          this.isFirstPageFinished = true;
        }).catch((err) => { console.error(err); });
    },

    infiniteHandler($state) {
      if (this.page + 1 > this.lastPage) {
        $state.complete();
        return;
      }

      getVideos({ params: { tags: this.$route.params.slug, limit: this.limit, page: this.page } })
        .then((result) => {
          const { data } = result.data;

          if (data.length > 0) {
            this.page += 1;
            this.list.push(...data);
            $state.loaded();
          } else {
            $state.complete();
          }
        }).catch((err) => { console.error(err); });
    },
  },
};
</script>
